export default {
    data () {
        return {
            value: '',
            placeHolder: 'Search game name'
        };
    },
    methods: {
        onSearch() {
            if(!this.value){
                this.$toast({
                    message:"The input value is null"
                });
                return;
            }
            window.location.href = `/search?val=${this.value}`
        },
    },
    created() {
        let { val } = this.$route.query
        if(val){
            this.placeHolder = val
        }
    },
}


// WEBPACK FOOTER //
// ./src/mixins/searchMixin.js